import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twosixseater() {



const cardData = {
keyword: "26 Seater Tempo Traveller on Rent in Pune",
headingDescription: "Ruturaj Enterprises offers reliable and comfortable 26 Seater Tempo Traveller on Rent in Pune for large families, corporate teams, wedding groups, school excursions, tourist parties, airport transfers, picnics, events, and outstation tours. A 26 seater Tempo Traveller is a practical group transportation option for travelers who want to stay together in one spacious vehicle, making long-distance journeys, sightseeing programs, special occasions, and organized group travel easier to manage.",
topPlaces: [
{
title: "Goa",
description: "Goa is a favorite destination for large family vacations, corporate outings, friends' trips, wedding groups, and organized tours from Pune. A 26 seater Tempo Traveller is suitable for larger groups traveling together on the long route while providing convenient space for passengers, luggage, and travel essentials."
},
{
title: "Shirdi",
description: "Shirdi attracts large pilgrimage groups, families, senior citizens, and devotees traveling from Pune throughout the year. A 26 seater Tempo Traveller provides a convenient shared transportation solution for temple visits and related sightseeing while keeping the complete group on one coordinated travel schedule."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill destination known for scenic viewpoints, pleasant weather, strawberry farms, and family-friendly attractions. Large families, school groups, corporate teams, and tourist parties can use a 26 seater Tempo Traveller for comfortable travel from Pune."
},
{
title: "Nashik",
description: "Nashik is suitable for pilgrimage tours, family holidays, vineyard visits, and group sightseeing. A 26 seater Tempo Traveller allows larger groups to travel together from Pune and conveniently plan visits to Nashik, Trimbakeshwar, and nearby attractions."
},
{
title: "Kolhapur",
description: "Kolhapur is known for religious attractions, historical locations, cultural experiences, and traditional cuisine. A 26 seater Tempo Traveller works well for large families and organized tourist groups that want one dedicated vehicle for the journey and local movements."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal destination for weekend holidays, family outings, corporate retreats, and group vacations. Larger groups traveling from Pune can choose a 26 seater Tempo Traveller to keep everyone together and accommodate luggage and beach-trip essentials."
},
{
title: "Aurangabad",
description: "Aurangabad, also known as Chhatrapati Sambhajinagar, is an important heritage destination with attractions connected to the Ajanta and Ellora travel circuit. A 26 seater Tempo Traveller is convenient for larger school groups, families, tourist parties, and organized historical tours."
},
{
title: "Lonavala",
description: "Lonavala remains one of the most popular short-trip destinations from Pune for families, schools, corporate teams, and large groups. A 26 seater vehicle makes group travel easier by providing shared transportation for sightseeing, picnics, resort visits, and weekend outings."
},
{
title: "Panchgani",
description: "Panchgani offers scenic mountain landscapes, viewpoints, pleasant surroundings, and attractions suitable for group holidays. A 26 seater Tempo Traveller provides a convenient option for larger groups traveling from Pune for family vacations, school excursions, and organized tours."
},
{
title: "Tarkarli",
description: "Tarkarli is a scenic coastal destination known for its beaches, water activities, and relaxed holiday atmosphere. Larger groups from Pune can use a 26 seater Tempo Traveller for a comfortable journey while carrying luggage, recreational equipment, and other essentials for an extended coastal trip."
}
],
services: [
{
name: "26 Seater Tempo Traveller Pune",
description: "Ruturaj Enterprises provides 26 Seater Tempo Traveller Pune services for large families, friends, corporate groups, wedding parties, school groups, tourist organizations, and event participants. The larger-capacity vehicle is suitable for local sightseeing, airport transfers, private functions, picnics, weekend trips, and long-distance journeys."
},
{
name: "26 Seater Tempo Traveller Hire Pune",
description: "26 Seater Tempo Traveller Hire Pune is a convenient option for larger groups that want to travel together instead of arranging multiple smaller vehicles. It can support family vacations, corporate programs, weddings, school excursions, sightseeing tours, events, and organized group travel."
},
{
name: "26 Seater Tempo Traveller Booking Pune",
description: "26 Seater Tempo Traveller Booking Pune can be planned for local travel, full-day sightseeing, weekend getaways, multi-day tours, wedding functions, corporate events, and outstation routes. Advance planning allows groups to coordinate passenger requirements, pickup locations, travel duration, destination routes, and itinerary details more effectively."
},
{
name: "26 Seater AC Tempo Traveller Pune",
description: "26 Seater AC Tempo Traveller Pune is suitable for larger groups who prefer air-conditioned transportation, particularly for long-distance journeys and travel during warmer months. It can be used for family vacations, corporate tours, wedding transportation, school trips, airport transfers, and tourist journeys."
},
{
name: "26 Seater Luxury Tempo Traveller Pune",
description: "26 Seater Luxury Tempo Traveller Pune provides a premium-oriented group transportation option for travelers who prioritize enhanced comfort. It is suitable for corporate events, wedding groups, special occasions, private tours, family holidays, and other important journeys involving a larger number of passengers."
},
{
name: "26 Seater Tempo Traveller for Outstation Pune",
description: "26 Seater Tempo Traveller for Outstation Pune offers a practical solution for large groups traveling from Pune to destinations across Maharashtra and neighboring states. A dedicated vehicle helps passengers remain together and makes it easier to coordinate luggage, travel stops, sightseeing, meals, and return schedules."
},
{
name: "26 Seater Tempo Traveller for Family Trip Pune",
description: "26 Seater Tempo Traveller for Family Trip Pune is ideal for extended families and relatives planning vacations, pilgrimages, weekend getaways, and destination tours. A spacious group vehicle allows family members to travel together while providing a convenient arrangement for luggage and common travel requirements."
},
{
name: "26 Seater Tempo Traveller for Group Travel Pune",
description: "26 Seater Tempo Traveller for Group Travel Pune is designed for large groups of friends, relatives, colleagues, tourists, and organized travelers. Using one dedicated vehicle can simplify route coordination, pickup arrangements, parking, luggage management, and group communication throughout the journey."
},
{
name: "26 Seater Tempo Traveller for Wedding Pune",
description: "26 Seater Tempo Traveller for Wedding Pune is suitable for transporting larger groups of wedding guests and relatives between hotels, homes, temples, marriage halls, reception venues, and other function locations. A dedicated vehicle helps maintain an organized transportation schedule during busy wedding programs."
},
{
name: "26 Seater Tempo Traveller for Corporate Events Pune",
description: "26 Seater Tempo Traveller for Corporate Events Pune can be arranged for conferences, seminars, exhibitions, employee gatherings, training programs, team outings, and business functions. It provides a convenient way for larger corporate groups to travel together between offices, hotels, venues, and event locations."
},
{
name: "26 Seater Tempo Traveller for School Trip Pune",
description: "26 Seater Tempo Traveller for School Trip Pune provides organized transportation for educational excursions, historical visits, museum tours, nature trips, recreational outings, and student activities. Schools and organizers can coordinate group transportation while keeping students, teachers, and accompanying staff together."
},
{
name: "26 Seater Tempo Traveller for Airport Pickup Pune",
description: "26 Seater Tempo Traveller for Airport Pickup Pune is useful for large families, corporate teams, wedding groups, tourist parties, and organized travelers arriving at or departing from Pune Airport. One dedicated vehicle makes passenger and luggage coordination easier than arranging several separate airport transfers."
},
{
name: "26 Seater Tempo Traveller Near Me Pune",
description: "26 Seater Tempo Traveller Near Me Pune is useful for groups searching for a larger-capacity traveller rental service in Pune. Ruturaj Enterprises supports requirements for airport transfers, local sightseeing, weddings, corporate travel, family vacations, school trips, picnics, and outstation tours."
},
{
name: "Affordable 26 Seater Tempo Traveller Pune",
description: "Affordable 26 Seater Tempo Traveller Pune offers a practical group transportation solution for travelers who want to share one vehicle instead of arranging multiple cars. It can be used for family tours, corporate journeys, weddings, school trips, picnics, tourist tours, and long-distance travel while keeping transportation organized."
},
{
name: "26 Seater Tempo Traveller for Picnic Pune",
description: "26 Seater Tempo Traveller for Picnic Pune is suitable for large families, office groups, schools, friends, community organizations, and recreational groups planning a picnic. The spacious vehicle helps keep everyone together while accommodating food, bags, outdoor equipment, and other trip essentials."
},
{
name: "26 Seater Tempo Traveller for Marriage Pune",
description: "26 Seater Tempo Traveller for Marriage Pune provides convenient transportation for larger groups of relatives and guests during marriage ceremonies and related functions. It can be used for scheduled movement between hotels, homes, temples, banquet halls, reception venues, and other locations included in the marriage itinerary."
},
{
name: "26 Seater Tempo Traveller for Corporate Travel Pune",
description: "26 Seater Tempo Traveller for Corporate Travel Pune is suitable for larger employee groups traveling for meetings, training sessions, business tours, client visits, office programs, and corporate activities. A dedicated vehicle helps the complete team follow a common travel schedule and reduces the need for multiple smaller vehicles."
},
{
name: "26 Seater Tempo Traveller for Event Pune",
description: "26 Seater Tempo Traveller for Event Pune can be arranged for exhibitions, conferences, cultural programs, private celebrations, social gatherings, corporate functions, and other events requiring group transportation. Event organizers can coordinate transportation between pickup points, hotels, venues, and other planned destinations."
},
{
name: "26 Seater Tempo Traveller for Tourist Trip Pune",
description: "26 Seater Tempo Traveller for Tourist Trip Pune provides convenient transportation for larger tourist groups visiting multiple attractions and destinations. It is suitable for sightseeing circuits, heritage tours, pilgrimage journeys, family vacations, weekend holidays, and organized travel programs departing from Pune."
},
{
name: "26 Seater Tempo Traveller for Outstation Tour Pune",
description: "26 Seater Tempo Traveller for Outstation Tour Pune is a practical choice for larger groups planning long-distance vacations, destination tours, pilgrimage trips, weekend getaways, and multi-day journeys. One dedicated vehicle simplifies passenger coordination, luggage handling, sightseeing stops, and return travel arrangements."
},
{
name: "26 Seater AC Traveller Rental Pune",
description: "26 Seater AC Traveller Rental Pune provides a comfortable shared transportation solution for larger groups traveling within Pune or to outstation destinations. Air-conditioned travel is especially suitable for longer routes, family holidays, corporate tours, wedding transportation, sightseeing programs, and airport transfers."
},
{
name: "26 Seater Luxury Traveller Hire Pune",
description: "26 Seater Luxury Traveller Hire Pune is suitable for large groups looking for a premium-oriented travel arrangement for important trips and special occasions. It can be considered for corporate events, wedding functions, private tours, family vacations, tourist journeys, and other group transportation requirements where enhanced comfort is preferred."
}
],
tableData: [
["26 Seater Tempo Traveller Pune", "26 Seater Tempo Traveller Hire Pune"],
["26 Seater Tempo Traveller Booking Pune", "26 Seater AC Tempo Traveller Pune"],
["26 Seater Luxury Tempo Traveller Pune", "26 Seater Tempo Traveller for Outstation Pune"],
["26 Seater Tempo Traveller for Family Trip Pune", "26 Seater Tempo Traveller for Group Travel Pune"],
["26 Seater Tempo Traveller for Wedding Pune", "26 Seater Tempo Traveller for Corporate Events Pune"],
["26 Seater Tempo Traveller for School Trip Pune", "26 Seater Tempo Traveller for Airport Pickup Pune"],
["26 Seater Tempo Traveller Near Me Pune", "Affordable 26 Seater Tempo Traveller Pune"],
["26 Seater Tempo Traveller for Picnic Pune", "26 Seater Tempo Traveller for Marriage Pune"],
["26 Seater Tempo Traveller for Corporate Travel Pune", "26 Seater Tempo Traveller for Event Pune"],
["26 Seater Tempo Traveller for Tourist Trip Pune", "26 Seater Tempo Traveller for Outstation Tour Pune"],
["26 Seater AC Traveller Rental Pune", "26 Seater Luxury Traveller Hire Pune"]
],
whychoose: [
{
WhyChooseheading: "Large Capacity for Group Journeys",
WhyChoosedescription: "A 26 seater Tempo Traveller is a suitable transportation choice for larger families, tourist parties, corporate teams, school groups, wedding guests, and organized travel groups. Keeping a large group together in one vehicle can make the complete journey easier to coordinate."
},
{
WhyChooseheading: "One Vehicle for Better Coordination",
WhyChoosedescription: "Large groups traveling in multiple cars often need to manage separate drivers, routes, parking arrangements, and arrival times. A dedicated 26 seater Traveller brings passengers together and simplifies communication, route planning, pickup arrangements, and sightseeing schedules."
},
{
WhyChooseheading: "Designed for Longer Routes",
WhyChoosedescription: "Outstation journeys frequently involve several passengers, luggage, scheduled breaks, and multiple destinations. A 26 seater Tempo Traveller provides a practical shared transportation arrangement for long-distance family vacations, pilgrimage tours, corporate trips, and multi-day tourist programs."
},
{
WhyChooseheading: "Ideal for Weddings and Large Functions",
WhyChoosedescription: "Wedding and marriage events often require transportation for many guests between different locations. A 26 seater vehicle can help move relatives and guests together between hotels, homes, temples, ceremony venues, and reception halls according to the planned function schedule."
},
{
WhyChooseheading: "Convenient Corporate Transportation",
WhyChoosedescription: "Large corporate groups can use a 26 seater Traveller for conferences, seminars, exhibitions, employee outings, training programs, business meetings, and company events. Shared transportation helps organizers manage group movement while allowing employees to follow a common schedule."
},
{
WhyChooseheading: "AC and Luxury Travel Choices",
WhyChoosedescription: "Travel requirements can vary based on the season, destination, duration, and purpose of the journey. AC and luxury-oriented options provide additional flexibility for groups seeking a cooler or more premium travel environment for long routes, special events, and private tours."
},
{
WhyChooseheading: "Suitable for School Trips and Picnics",
WhyChoosedescription: "Educational excursions, school tours, picnics, and recreational outings can involve a substantial number of participants traveling to the same destination. A 26 seater vehicle provides a shared transportation arrangement that makes group movement and itinerary coordination more convenient."
},
{
WhyChooseheading: "Flexible for Diverse Travel Requirements",
WhyChoosedescription: "The vehicle can support a wide range of travel needs, including airport transfers, local sightseeing, tourist trips, family vacations, corporate transportation, weddings, events, picnics, and outstation tours. Ruturaj Enterprises helps groups plan transportation around passenger capacity, destination, travel duration, pickup points, and itinerary requirements."
}
]
};







const faqData = [
{
question: "Why choose Ruturaj Enterprises for a 26 Seater Tempo Traveller on rent in Pune?",
answer: "Ruturaj Enterprises offers 26 Seater Tempo Traveller rental services for large groups looking for a convenient way to travel together. The vehicle is suitable for family tours, corporate outings, weddings, school and college trips, pilgrimages, sightseeing programs, and outstation journeys."
},
{
question: "Who can hire a 26 Seater Tempo Traveller in Pune?",
answer: "Families, tour operators, corporate teams, wedding groups, educational institutions, social organizations, and large travel groups can choose a 26 Seater Tempo Traveller when they require spacious group transportation from Pune."
},
{
question: "Can I rent a 26 Seater Tempo Traveller from Pune for an outstation trip?",
answer: "A 26 Seater Tempo Traveller can be arranged for outstation travel from Pune to destinations such as Mumbai, Goa, Shirdi, Mahabaleshwar, Nashik, Kolhapur, Konkan, and other popular routes. The rental can be planned according to the destination, journey duration, and group requirements."
},
{
question: "Is a 26 Seater Tempo Traveller suitable for family tours?",
answer: "Large families can use a 26 Seater Tempo Traveller for vacations, reunions, religious journeys, destination visits, and multi-day tours. Keeping everyone together in one vehicle makes group coordination easier and creates a more convenient travel arrangement."
},
{
question: "Can I book a 26 Seater Tempo Traveller for weddings in Pune?",
answer: "Wedding families can hire a 26 Seater Tempo Traveller to transport relatives and guests between homes, hotels, wedding venues, reception locations, railway stations, and airports. Its larger seating capacity is particularly useful when many guests need transportation at the same time."
},
{
question: "Can corporate groups hire a 26 Seater Tempo Traveller in Pune?",
answer: "Companies can arrange a 26 Seater Tempo Traveller for employee outings, conferences, seminars, team-building activities, business events, training programs, industrial visits, and corporate tours. Group transportation helps employees travel together while keeping the planned schedule organized."
},
{
question: "Is a 26 Seater Tempo Traveller good for school and college trips?",
answer: "Schools and colleges can consider a 26 Seater Tempo Traveller for educational tours, picnics, excursions, industrial visits, cultural programs, and recreational trips. Dedicated group transportation can make the journey easier to coordinate from pickup through the return trip."
},
{
question: "Can I hire a 26 Seater Tempo Traveller for Pune sightseeing?",
answer: "Groups interested in exploring Pune and nearby attractions can rent a 26 Seater Tempo Traveller for sightseeing programs. It is a practical option for larger groups that want to visit multiple locations together without arranging separate vehicles for different passengers."
},
{
question: "Can a 26 Seater Tempo Traveller be used for airport transfers in Pune?",
answer: "A 26 Seater Tempo Traveller can be useful for airport transfers involving tour groups, wedding parties, corporate teams, and large families. Group members can travel together from Pune Airport to hotels, homes, event venues, or onward destinations while managing luggage more conveniently."
},
{
question: "How can I book a 26 Seater Tempo Traveller on rent in Pune?",
answer: "To plan a 26 Seater Tempo Traveller rental with Ruturaj Enterprises, provide details such as your pickup point, travel date, destination, number of passengers, journey duration, and route requirements. The transportation arrangement can then be planned around your group's itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sandeep Jadhav",
feedback:
"Our family group hired a 26 Seater Tempo Traveller from Ruturaj Enterprises for an outstation tour from Pune. Having everyone travel together made the journey much easier to coordinate, especially during the longer parts of the trip. The overall arrangement worked very well for our large group.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Kulkarni",
feedback:
"We selected a 26 Seater Tempo Traveller from Ruturaj Enterprises for our college group trip. Managing transportation for so many students was simple because everyone could stay together throughout the journey. It was a convenient choice for our sightseeing and travel schedule.",
rating: 5
}
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "26 Seater Tempo Traveller on Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/26-seater-tempo-traveller-on-rent-in-pune.webp",
  "description":
    "26 Seater Tempo Traveller on Rent in Pune from Ruturaj Enterprises is a spacious group transportation option for large families, friends, corporate teams, wedding groups, tourists, school groups, college groups and organizations traveling together. 26 Seater Tempo Traveller Pune is suitable for sightseeing, family tours, corporate transportation, wedding guest movement, school excursions, college tours, pilgrimage journeys, airport transfers and long-distance outstation travel. 26 Seater Tempo Traveller Hire Pune provides a convenient way for larger groups to travel together in one vehicle instead of arranging multiple smaller vehicles, helping simplify group movement and travel coordination. 26 Seater Tempo Traveller Booking Pune can be planned according to the pickup point, destination, travel schedule, journey duration and passenger requirements. 26 Seater AC Tempo Traveller Pune is suitable for comfortable travel during warm weather and longer journeys, while 26 Seater Luxury Tempo Traveller Pune can be considered for premium group transportation during corporate events, weddings, special occasions, tours and organized travel programs. 26 Seater Tempo Traveller for Outstation Pune is suitable for journeys to Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran, Ratnagiri, Ganpatipule and other Maharashtra and interstate destinations. The vehicle is also useful for family vacations, group tours, friends trips, weekend getaways, tourist excursions, school picnics, college tours, industrial visits and customized multi-day road trips. Wedding transportation can cover guest movement between hotels, venues, reception locations, airports and railway stations, while corporate travel can support employee outings, conferences, seminars, exhibitions, meetings, training programs, business visits and team events. Airport pickup and drop, railway station transfers, hotel transfers and resort transportation can be included in customized itineraries. Pune Darshan, temple tours, pilgrimage journeys, religious tours and local sightseeing can also be arranged with a dedicated driver. Pickup and drop facilities can be planned from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and surrounding Pune areas. Ruturaj Enterprises supports flexible full-day, weekend, multi-day, local and outstation 26 Seater Tempo Traveller rental requirements for family travel, corporate transportation, weddings, school trips, college tours, sightseeing, events, pilgrimages and customized group journeys from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/26-seater-tempo-traveller-on-rent-in-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>26 Seater Tempo Traveller on Rent in Pune | 26 Seater Tempo Traveller Pune | +91 9763381382</title>

  <meta
    name="description"
    content="26 Seater Tempo Traveller on Rent in Pune for large group tours, family trips, corporate events, weddings, school tours, sightseeing, airport transfers and outstation journeys with driver."
  />

  <meta
    name="keywords"
    content="26 Seater Tempo Traveller Pune, 26 Seater Tempo Traveller Hire Pune, 26 Seater Tempo Traveller Booking Pune, 26 Seater AC Tempo Traveller Pune, 26 Seater Luxury Tempo Traveller Pune, 26 Seater Tempo Traveller for Outstation Pune, 26 Seater Tempo Traveller for Family Trip Pune, 26 Seater Tempo Traveller for Group Travel Pune, 26 Seater Tempo Traveller for Wedding Pune, 26 Seater Tempo Traveller for Corporate Events Pune, 26 Seater Tempo Traveller for School Trip Pune, 26 Seater Tempo Traveller for College Trip Pune, 26 Seater Tempo Traveller for Airport Pickup Pune, 26 Seater Tempo Traveller on Rent in Pune, 26 Seater Tempo Traveller Rental Pune, 26 Seater Tempo Traveller Hire in Pune, 26 Seater Tempo Traveller Booking in Pune, 26 Seater Tempo Traveller with Driver Pune, 26 Seater Private Tempo Traveller Pune, 26 Seater AC Tempo Traveller on Rent Pune, 26 Seater AC Tempo Traveller Hire Pune, 26 Seater AC Tempo Traveller Rental Pune, 26 Seater Luxury Tempo Traveller on Rent Pune, 26 Seater Luxury Tempo Traveller Hire Pune, 26 Seater Luxury Tempo Traveller Rental Pune, Premium 26 Seater Tempo Traveller Pune, Affordable 26 Seater Tempo Traveller Pune, 26 Seater Tempo Traveller for Large Group Pune, 26 Seater Tempo Traveller for Group Tour Pune, 26 Seater Tempo Traveller for Friends Trip Pune, 26 Seater Tempo Traveller for Family Tour Pune, 26 Seater Tempo Traveller for Family Vacation Pune, 26 Seater Tempo Traveller for Weekend Trip Pune, 26 Seater Tempo Traveller for Holiday Trip Pune, 26 Seater Tempo Traveller for Road Trip Pune, 26 Seater Tempo Traveller for Sightseeing Pune, 26 Seater Tempo Traveller for Local Sightseeing Pune, 26 Seater Tempo Traveller for Pune Darshan, 26 Seater Tempo Traveller for Maharashtra Tour Pune, 26 Seater Tempo Traveller for Goa Trip Pune, 26 Seater Tempo Traveller for Mumbai Trip Pune, 26 Seater Tempo Traveller for Lonavala Trip Pune, 26 Seater Tempo Traveller for Mahabaleshwar Trip Pune, 26 Seater Tempo Traveller for Panchgani Trip Pune, 26 Seater Tempo Traveller for Nashik Trip Pune, 26 Seater Tempo Traveller for Shirdi Trip Pune, 26 Seater Tempo Traveller for Kolhapur Trip Pune, 26 Seater Tempo Traveller for Satara Trip Pune, 26 Seater Tempo Traveller for Konkan Trip Pune, 26 Seater Tempo Traveller for Alibaug Trip Pune, 26 Seater Tempo Traveller for Matheran Trip Pune, 26 Seater Tempo Traveller for Ratnagiri Trip Pune, 26 Seater Tempo Traveller for Ganpatipule Trip Pune, 26 Seater Tempo Traveller for Dapoli Trip Pune, 26 Seater Tempo Traveller for Outstation Trip Pune, 26 Seater Tempo Traveller Outstation Rental Pune, 26 Seater Tempo Traveller One Way Pune, 26 Seater Tempo Traveller Round Trip Pune, 26 Seater Tempo Traveller Full Day Rental Pune, 26 Seater Tempo Traveller Multi Day Rental Pune, 26 Seater Tempo Traveller Weekend Rental Pune, 26 Seater Tempo Traveller Tour Package Pune, 26 Seater Tempo Traveller Sightseeing Package Pune, 26 Seater Tempo Traveller Family Tour Package Pune, 26 Seater Tempo Traveller Group Tour Package Pune, 26 Seater Tempo Traveller Corporate Tour Pune, 26 Seater Tempo Traveller Corporate Travel Pune, 26 Seater Tempo Traveller for Corporate Outing Pune, 26 Seater Tempo Traveller for Employee Transportation Pune, 26 Seater Tempo Traveller for Office Trip Pune, 26 Seater Tempo Traveller for Company Event Pune, 26 Seater Tempo Traveller for Business Travel Pune, 26 Seater Tempo Traveller for Conference Pune, 26 Seater Tempo Traveller for Seminar Pune, 26 Seater Tempo Traveller for Exhibition Pune, 26 Seater Tempo Traveller for Training Pune, 26 Seater Tempo Traveller for Industrial Visit Pune, 26 Seater Tempo Traveller for Wedding Guest Pune, 26 Seater Tempo Traveller for Marriage Pune, 26 Seater Tempo Traveller for Reception Pune, 26 Seater Tempo Traveller for Destination Wedding Pune, 26 Seater Tempo Traveller for Wedding Guest Transportation Pune, 26 Seater Tempo Traveller for Event Transportation Pune, 26 Seater Tempo Traveller for Airport Transfer Pune, 26 Seater Tempo Traveller for Airport Pickup Pune, 26 Seater Tempo Traveller for Airport Drop Pune, 26 Seater Tempo Traveller for Pune Airport, 26 Seater Tempo Traveller for Railway Station Transfer Pune, 26 Seater Tempo Traveller for Pune Railway Station, 26 Seater Tempo Traveller for Hotel Transfer Pune, 26 Seater Tempo Traveller for Resort Transfer Pune, 26 Seater Tempo Traveller for Guest Pickup Pune, 26 Seater Tempo Traveller for Guest Drop Pune, 26 Seater Tempo Traveller for School Tour Pune, 26 Seater Tempo Traveller for Student Group Pune, 26 Seater Tempo Traveller for School Picnic Pune, 26 Seater Tempo Traveller for College Tour Pune, 26 Seater Tempo Traveller for Temple Tour Pune, 26 Seater Tempo Traveller for Pilgrimage Pune, 26 Seater Tempo Traveller for Religious Tour Pune, 26 Seater Tempo Traveller for Tourist Group Pune, 26 Seater Tempo Traveller for Group Transportation Pune, 26 Seater Tempo Traveller for Family Transportation Pune, 26 Seater Tempo Traveller for Corporate Transportation Pune, 26 Seater Tempo Traveller for Event Transportation Pune, 26 Seater Tempo Traveller Rental Near Pune, 26 Seater Tempo Traveller Hire Near Pune, 26 Seater Tempo Traveller Booking Near Pune, 26 Seater Tempo Traveller Rental Pimpri Chinchwad, 26 Seater Tempo Traveller Hire Pimpri Chinchwad, 26 Seater Tempo Traveller Rental Wakad, 26 Seater Tempo Traveller Rental Hinjewadi, 26 Seater Tempo Traveller Rental Kothrud, 26 Seater Tempo Traveller Rental Baner, 26 Seater Tempo Traveller Rental Aundh, 26 Seater Tempo Traveller Rental Viman Nagar, 26 Seater Tempo Traveller Rental Kharadi, 26 Seater Tempo Traveller Rental Hadapsar, 26 Seater Tempo Traveller Rental Kondhwa, 26 Seater Tempo Traveller Rental Katraj, 26 Seater Tempo Traveller Rental Shivajinagar, 26 Seater Tempo Traveller Rental Swargate, 26 Seater Tempo Traveller Rental Pimpri, 26 Seater Tempo Traveller Rental Chinchwad, 26 Seater Tempo Traveller Rental Talegaon, 26 Seater Tempo Traveller Rental Moshi, 26 Seater Tempo Traveller Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Twosixseater ;